"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _OffCanvas = _interopRequireDefault(require("./OffCanvas"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _OffCanvas["default"];
exports["default"] = _default;